/**
 * 性能指标上报。用 web-vitals 库拿 LCP、INP、CLS、TTFB,攒着,页面隐藏(切走、关掉)时一次发出去。
 * 每条带:构建版本、路由(商品页不带具体 slug,好按页面聚合)、网络类型。
 */
import { onLCP, onINP, onCLS, onTTFB, type Metric } from "web-vitals";

const VERSION = import.meta.env.VITE_VERSION as string;
const queue: object[] = [];

const route = () => location.pathname.replace(/^\/p\/[^/]+/, "/p/:slug");
const connection = () => (navigator as Navigator & { connection?: { effectiveType?: string } }).connection?.effectiveType ?? "";

function push(m: Metric) {
  queue.push({ name: m.name, value: Math.round(m.value * 1000) / 1000, rating: m.rating, path: route(), version: VERSION, connection: connection() });
}
onLCP(push); onINP(push); onCLS(push); onTTFB(push);

function flush() {
  if (queue.length === 0) return;
  const body = JSON.stringify(queue.splice(0));
  fetch("/api/vitals", { method: "POST", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => {});
}
addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") flush(); });
addEventListener("pagehide", flush);
